// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBCUXpgauUf6QtVyyh_iWZJlnn7OkTlIMg",
  authDomain: "l2calculate.firebaseapp.com",
  projectId: "l2calculate",
  storageBucket: "l2calculate.firebasestorage.app",
  messagingSenderId: "87524082786",
  appId: "1:87524082786:web:0b05a50fa7b8d4e7723d3b",
  measurementId: "G-PHH1NS9477"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
